export default {
  graphicon: require("./opendashboardimages/icons/graphIcon.png"),
  verifyicon: require("./opendashboardimages/icons/verifyIcon.png"),
  openicon: require("./opendashboardimages/icons/openIcon.png"),
  checkicon: require("./opendashboardimages/icons/checkIcon.png"),
  crossicon: require("./opendashboardimages/icons/crossIcon.png"),
  escalated: require("./opendashboardimages/icons/escalated.png"),
  declined: require("./opendashboardimages/icons/declined.png"),
  mainlogo: require("./opendashboardimages/logo.jpg"),

  overviewicon: require("./opendashboardimages/icons/overview.png"),
  serviceIndicatorIcon1: require("./opendashboardimages/icons/commoditiesIcon.png"),
  serviceIndicatorIcon2: require("./opendashboardimages/icons/treatmentIcon.png"),
  serviceIndicatorIcon3: require("./opendashboardimages/icons/rightsIcon.png"),
  serviceIndicatorIcon4: require("./opendashboardimages/icons/supportIcon.png"),
  serviceIndicatorIcon5: require("./opendashboardimages/icons/deliveryIcon.png"),
};
